


























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { numberToHumanSize } from 'bits/numbers_helper'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonSizePreset,
  OzContainedButtonColorScheme,
} from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import OzMembershipTierGrid from 'library/v4/components/OzMembershipTierGrid.vue'
import { User } from 'types'

export enum Variant {
  UnderPadletQuota,
  AtPadletQuota,
  OverPadletQuota,
  FileSize,
  SignUp,
  Continue,
  ContinueOld,
  UnderPadletQuotaOld,
  AtPadletQuotaOld,
  OverPadletQuotaOld,
  FileSizeQuotaOld,
}

@Component({ components: { OzBox, OzContainedButton, OzIcon, OzLoadingSpinner, OzMembershipTierGrid } })
export default class NeonMembershipTier extends Vue {
  @Prop() user!: User
  @Prop() fileSize!: number

  /**
   * Defines which variant should be displayed.
   */
  @Prop({ required: true }) variant!: Variant

  /**
   * Part of Experiment 3 Visuals - to remove after experiment.
   */
  @Prop() experimentalPlanName!: string
  @Prop() experimentalBackgroundColor!: OzBoxColors
  @Prop() experimentalButtonColor!: OzContainedButtonColorScheme

  /**
   * Determines whether the OzMembershipTierGrid component should be expanded or not.
   */
  @Prop({ required: true }) isExpanded!: boolean

  /**
   * Determines whether the plan information is being loaded or not.
   */
  @Prop({ required: true }) isLoadingPlanInformation!: boolean

  /**
   * Determines whether to show the checkmark next to the tier name or not.
   */
  @Prop({ default: false }) xChecked!: boolean

  /**
   * The maximum amount of walls allowed in this Tier
   */
  @Prop({ required: true }) advertisedWallsQuota!: number

  /**
   * The maximum upload file size allowed in this Tier
   */
  @Prop({ required: true }) advertisedFileSizeQuota!: string

  /**
   * Whether Advertised Quotas have been fetched
   */
  @Prop({ required: true }) isLoadingAdvertisedQuotas!: boolean

  numberToHumanSize = numberToHumanSize
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  Variant = Variant

  get isPadletQuotaOrFileSizeVariant(): boolean {
    return (
      this.variant === Variant.UnderPadletQuota ||
      this.variant === Variant.AtPadletQuota ||
      this.variant === Variant.OverPadletQuota ||
      this.variant === Variant.FileSize ||
      this.variant === Variant.UnderPadletQuotaOld ||
      this.variant === Variant.AtPadletQuotaOld ||
      this.variant === Variant.OverPadletQuotaOld ||
      this.variant === Variant.FileSizeQuotaOld
    )
  }

  get isOldVariant(): boolean {
    return (
      this.variant === Variant.ContinueOld ||
      this.variant === Variant.UnderPadletQuotaOld ||
      this.variant === Variant.AtPadletQuotaOld ||
      this.variant === Variant.OverPadletQuotaOld ||
      this.variant === Variant.FileSizeQuotaOld
    )
  }

  get planName(): string {
    if (!this.isOldVariant) return this.__('Neon')
    if (this.experimentalPlanName) return this.experimentalPlanName // only override old variants
    return this.__('Basic')
  }

  get colorScheme(): OzBoxColors | null {
    if (this.isOldVariant && !!this.experimentalBackgroundColor) return this.experimentalBackgroundColor // only override old variants
    if (this.isPadletQuotaOrFileSizeVariant) return OzBoxColors.Secondary
    if (this.variant === Variant.Continue) return OzBoxColors.Pink
    if (this.isOldVariant) return OzBoxColors.Secondary
    return null
  }
}
